/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Web_Card3_TitleInputs */

const tr_landing_web_card3_title = /** @type {(inputs: Landing_Web_Card3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kendi ödemeniz, kendi kargonuz`)
};

const en_landing_web_card3_title = /** @type {(inputs: Landing_Web_Card3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your payments, your shipping`)
};

const de_landing_web_card3_title = /** @type {(inputs: Landing_Web_Card3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre Zahlung, Ihr Versand`)
};

const ru_landing_web_card3_title = /** @type {(inputs: Landing_Web_Card3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваши платежи, ваша доставка`)
};

/**
* | output |
* | --- |
* | "Your payments, your shipping" |
*
* @param {Landing_Web_Card3_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_web_card3_title = /** @type {((inputs?: Landing_Web_Card3_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Web_Card3_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_web_card3_title(inputs)
	if (locale === "de") return de_landing_web_card3_title(inputs)
	if (locale === "ru") return ru_landing_web_card3_title(inputs)
	return tr_landing_web_card3_title(inputs)
});